import { createWorkspaceTabNavigator } from "../WorkspaceTabNavigator";

// Parameter list for the Tabs
export type WorkspaceAnalyticsTabParamList = {
  WorkspaceAnalyticsMain: undefined; // Renamed from 'WorkspaceAnalyticsMain' to avoid conflict potentially
  WorkspaceDataTodoMain: undefined;
};

// Create the custom Tab Navigator
export const WorkspaceAnalyticsTab =
  createWorkspaceTabNavigator<WorkspaceAnalyticsTabParamList>();
